import React from 'react'
import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { RootLayout } from '@components'
import {
  ProjectsPage,
  CertificationsPage,
  ContributorsPage,
  ErrorPage,
  ContributorPage,
  CertificationPage,
  UserPage,
} from '@pages'

import { rootUrl, routes } from './route-declarations'

export const AppRouter = function () {
  const router = createBrowserRouter(
    createRoutesFromElements([
      /* with top navigation*/
      <Route path={rootUrl.path} element={<RootLayout />} errorElement={<ErrorPage />}>
        {/*TODO HIDE - don't delete*/}
        {/*<Route path={routes.dashboard.path} element={<DashboardPage />} />*/}
        <Route path={routes.certifications.path} element={<CertificationsPage />} />
        <Route path={routes.certification.path} element={<CertificationPage />} />
        {/*TODO HIDE - don't delete*/}
        {/*<Route path={routes.activity.path} element={<ActivityPage />} />*/}
        <Route path={routes.projects.path} element={<ProjectsPage />} />
        <Route path={routes.contributors.path} element={<ContributorsPage />} />
        <Route path={routes.contributor.path} element={<ContributorPage />} />
        <Route path={routes.informations.path} element={<UserPage />} />
      </Route>,
    ]),
  )

  return <RouterProvider router={router} />
}
